@for (warnData of warningService.sortedWarningData(); track $index) {
  <mat-card
    appearance="outlined"
    class="warning-card"
    (click)="onShowWarningsForRegion(warnData.region)">
    <mat-card-header>
      <fa-icon
        mat-card-avatar
        [icon]="['far', warnData.warning.symbol]"
        [ngClass]="'warn-color-' + warnData.warning.color"
        size="2x"
        transform="down-8 right-2"></fa-icon>
      <mat-card-title>
        {{ warnData.region.name }}
      </mat-card-title>
      <mat-card-subtitle>{{
        'PRODUCT.WARNING.SEASON.' + warnData.region.season | translate
      }}</mat-card-subtitle>
      <!-- <mat-card-subtitle>{{ ('PRODUCT.WARNING.SEASON.' + warnData.region.season) | translate }}</mat-card-subtitle> -->
    </mat-card-header>
    <mat-card-content>
      <div [ngClass]="'overview-warning__box--' + warnData.warning.color">
        <p class="mat-body-strong overview-warning__title">
          {{ 'PRODUCT.WARNING.TYPE.' + warnData.warning.type | translate }}
        </p>
        <div class="overview-warning__date">
          <fa-icon [icon]="['far', 'clock']"></fa-icon>
          {{
            warnData.warning.dtg
              | datex
                : 'dd DD.MM.YY HH:mm'
                : undefined
                : languageService.langSignal()
          }}
          {{ 'DATETIME.CLOCK' | translate }}
        </div>
        <ng-container
          *ngTemplateOutlet="
            warnData.warning.type !== 'VORAB' ? standard : vorab;
            context: { $implicit: warnData.warning.message.split(',,') }
          "></ng-container>
        <ng-template #standard>
          <p class="overview-warning__text-container">
            <app-no-warning
              [type]="warnData.warning['type']"
              [message]="warnData.warning.message">
            </app-no-warning>
          </p>
        </ng-template>
        <ng-template #vorab let-warning>
          <p class="overview-warning__text-container">
            @for (line of warning; track $index; let i = $index) {
              @if (i > 0) {
                @for (chunk of line.split(','); track $index; let j = $index) {
                  <div
                    [ngClass]="
                      j === 0
                        ? 'mat-body-strong'
                        : 'mat-body overview-warning__single-warning-text'
                    ">
                    {{ chunk }}
                  </div>
                }
              }
            }
          </p>
        </ng-template>
      </div>
    </mat-card-content>
  </mat-card>
}
